import { Typography, useTheme } from "@mui/material";
import { Box, Stack } from "@mui/system";

export function AlertInfo({
  message,
  type = "error",
  icon,
  messageHeader
}: {
  message: string;
  type?: "error" | "warning" | "sanitize";
  icon?: React.ReactNode;
  messageHeader?: string;
}) {
  const palette = useTheme().palette;
  const getBackgroundColor = () => {
    switch (type) {
      case "error":
        return "error.light";
      case "warning":
        return "warning.light";
      default:
        return "infoPurple.main";
    }
  };

  const getTextColor = () => {
    switch (type) {
      case "error":
        return "error.main";
      case "warning":
        return "warning.contrastText";
      default:
        return "infoPurple.contrastText";
    }
  };

  const getBorderStyle = () => {
    switch (type) {
      case "sanitize":
        return `1px solid ${palette.infoPurple.dark}`;
      case "warning":
        return `1px solid ${palette.warning.dark}`;
      case "error":
        return `1px solid ${palette.error.dark}`;
      default:
        return "none";
    }
  };

  const backgroundColor = getBackgroundColor();
  const textColor = getTextColor();
  const borderStyle = getBorderStyle();
  return (
    <Box
      sx={{
        backgroundColor,
        p: 1,
        mx: 4,
        my: 1,
        borderRadius: 1,
        border: borderStyle
      }}
      aria-label="alert-info"
      alignContent="center"
    >
      <Stack direction="row" alignItems="center" gap={1}>
        {icon}
        <Stack direction="column">
          {messageHeader && (
            <Typography color={textColor} variant="h6">
              {messageHeader}
            </Typography>
          )}
          <Typography color={textColor} variant="body1">
            {message}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
